import { TextInput, Filter } from 'react-admin';

export const FilterList = ({ source = 'name', ...props }) => {
  return (
    <Filter {...props}>
      <TextInput label="Search" source={source} alwaysOn />
    </Filter>
  );
};
